import { CheckSquare } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const checksNav: NavEntry = {
  label: 'Checks',
  icon: CheckSquare,
  path: '/checks',
  permission: 'checks:read',
  order: 10,
}
